import Vue from 'vue';
import resource from 'vue-resource'
import store from './store'
import router from './router'
Vue.use(resource)
Vue.use(router)
class Ajax {
    constructor() {
        // this.URI = 'http://xiaolong.drwine.com.cn/api/web/';
        this.URI = 'https://api.insideburgundy.cn/api/web/';
        this.TimeOut = null
    }

    userdata() {
        let data = {}
        if (store.state.userdata) {
            data = store.state.userdata
        }

        return data
    }

    vget(url, query = {}) {
        if (this.userdata().userId) {
            query.userId = this.userdata().userId
        };
        return Vue.http.get(this.URI + url, { params: query }).then(res => {
            if (res.status) {
                return res.body
            }
        })
    }

    vpost(url, params = {}) {
        if (this.userdata().userId) {
            params.userId = this.userdata().userId
        };
        return Vue.http.post(this.URI + url, params).then(res => {
            if (res.status) {
                return res.body
            }
        })
    }

    getColour() {
        //颜色
        return this.vget('colour')
    }

    getproducer() {
        // 酒庄
        return this.vget('producer')
    }

    getsearch(query = {}) {
        // 搜索
        return this.vget('search', query)
    }

    getvillage() {
        // 村庄
        return this.vget('village')
    }

    getvineyard() {
        // 田块
        return this.vget('vineyard')
    }

    getvintage() {
        // 年份
        return this.vget('vintage')
    }

    getfilters() {
        // 分类
        return this.vget('search/filters')
    }

    getlatest() {
        // new 酒评
        return this.vget('tastingReport/latest')
    }

    getactivity() {
        // 活动列表
        return this.vget('activities')
    }

    getactivityDetail(id) {
        // 活动详情
        return this.vget(`activity/${id}`)
    }

    postRegister(data) {
        //登录接口
        return this.vpost('register', data)
    }

    postSendCode(data) {
        // 验证码
        return this.vpost('send/code', data)
    }

    getNewsLatest(pageSize = 4) {
        // 最新资讯
        return this.vget('news/latest', { pageSize })
    }
    getNewsLaest(pageSize = 20) {
        // 最新资讯
        return this.vget('news/latest', { pageSize })
    }
    getNewDetail(id) {
        // 资讯详情
        return this.vget('tastingReport/' + id)
    }

    postLogin(data) {
        // 登录
        return this.vpost('login', data)
    }
    getUserInfo(id) {
        //个人资料
        return this.vget('user/' + id)
    }
    getUserInfa(id) {
        //书签
        return this.vget('user/' + id + '/favor')
    }
    getVserInfe(query) {
        // 收藏到书签
        return this.vget('favor', query)
    }
    getUserInfe(id) {
        //历史
        return this.vget('user/' + id + '/read')
    }
    getVssInfe(id) {
        //历史
        return this.vget('user/' + id + '/read')
    }
    postVCodeLogin(data) {
        // 验证码登录
        return this.vpost('login/vcode', data)
    }

    postResetPassword(data) {
        // 重置密码
        return this.vpost('reset/password', data)
    }

    getlatestList() {
        // new 酒评
        return this.vget('tastingReport/latest', { pageSize: 8 })
    }

    getTastingDetail(id) {
        // 酒评详情
        return this.vget('tastingReport/' + id)
    }

    getTastingNote(id) {
        // 笔记详情
        return this.vget('tastingNote/' + id)
    }

    getcategories() {
        // 右则菜单
        return this.vget('tastingNote/categories')
    }

    getPagelatest(query) {
        // 酒评
        return this.vget('page/tastingReport/latest', query)
    }

    getTastingNotes(query) {
        // 五星笔记
        return this.vget('tastingNotes', query)
    }

    getReportCategories() {
        // 报告分类
        return this.vget('tastingReport/categories')
    }

    getNewsCategories() {
        // 资讯分类
        return this.vget('news/categories')
    }

    getPay(callback) {
        return this.vpost('pay').then(res => {
            if (res.success) {
                this.getKeepPay(res.data.orderId, callback)
                return res
            } else {
                alert('请求支付时发现了一个错误，请刷新页面重试！')
            }
        })
    }

    getKeepPay(orderId, callback) {
        if (this.TimeOut) {
            clearTimeout(this.TimeOut)
        };
        let _this = this
        this.vget('pay/result', { orderId }).then(res => {
            if (res.success) {

                if (res.data === 5) {
                    if (callback && typeof callback == 'function') {
                        callback()
                    }
                } else {
                    if (router.app.$route.name == 'Subscribe') {
                        _this.TimeOut = setTimeout(() => {
                            _this.getKeepPay(orderId, callback)
                        }, 1000)
                    }
                }
            } else {
                alert('服务器错误，请刷新页面查看支付结果，如已支付成功，请匆重复提交！')
            }
        })
    }


}

export default new Ajax()


// WEBPACK FOOTER //
// ./src/ajax.js